import React from 'react'
import Form from "../../../components/form/Form";
import Page from "../../Page";
import FlipMove from "react-flip-move";
import EmptyBanner from "../../../components/EmptyBanner";
import ErrorBanner from "../../../components/ErrorBanner";
import NEWSkillFormButton from '../../profiles/components/NEWSkillFormButton';


export default class TalentSkillForm extends Page {

    /**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props) {
        super(props);

        this.modalRef = React.createRef();
        this.loadTimeout = null;

        this.state = {
            model: {
                search: '',
            },
            searchLoading: false,
            searchError: false,
            suggestedSkills: []
        }
    }


    /**
     * The fields mapping for the form
     */
    formFields = () => {

        let {
            talent_disciplines,
            skills
        } = this.props.user;

        let formFields = [];

        if (skills?.length > 0) {
            formFields.push(
                {
                    style: styles.fieldSection,
                    fields: {
                        skills: {
                            component: (
                                <div className={"form-group"} style={styles.field}>
                                    <label className="col-form-label">
                                        Your Skills
                                    </label>
                                    <div className="discipline-skills-container gap-3">
                                        <FlipMove typeName={null} maintainContainerHeight={true}>
                                            {skills.map((skill, index) => (
                                                <div key={skill.id}>
                                                    <NEWSkillFormButton
                                                        key={skill.id}
                                                        disabled={this.props.disabled}
                                                        skill={skill}
                                                        className={skill.category && "min-w-[165px]"}
                                                        scoringOptions={skill.category ? laravel.talent_scoring_options_by_category[skill.category] : laravel.talent_scoring_options}
                                                        type={skill.category ? 'info' : 'default'}
                                                        onChange={(model) => this.selectSkill(model)}
                                                    />
                                                </div>
                                            ))}
                                        </FlipMove>
                                    </div>
                                </div>
                            ),
                        },
                    }
                })
        }

        formFields.push({
            style: styles.fieldSection,
            fields: {
                search: {
                    label: TB.trans('talent.talent_skills_form.search_label'),
                    style: styles.field,
                    placeholder: TB.trans('talent.talent_skills_form.search_placeholder'),
                    type: 'search',
                    searchType: 'skills',
                    valueLabelDisplay: 'name',
                    disabled: this.props.disabled,
                    searchRequestEndpoint: '/api/talent-skills/search',
                    required: false,
                    autoComplete: 'off',
                    columns: 12,
                    onSuggestionsFetched: async (suggestedSkills) => {
                        this.promisedState({ suggestedSkills, searchError: false })
                    },
                    onLoading: async (searchLoading) => {
                        clearTimeout(this.loadTimeout);
                        if (searchLoading) {
                            return this.promisedState({ searchLoading, searchError: false });
                        }
                        await this.promisedState({ searchError: false });

                        this.loadTimeout = setTimeout(() => {
                            return this.promisedState({ searchLoading })
                        }, 250)
                    },
                    onError: async (searchError) => {
                        clearTimeout(this.loadTimeout)
                        await this.promisedState({ searchError, suggestedSkills: [] });

                        this.loadTimeout = setTimeout(() => {
                            return this.promisedState({ searchLoading: false })
                        }, 250)
                    }
                },

            }
        })

        return formFields;
    };


    /***********************************
     * Update Project Position
     ************************************/
    async selectSkill(model) {

        let user = TB.pick({ ...this.props.user }, 'skills');
        let skillIndex = TB.findIndex([...user.skills], ['id', model.id]);

        if (skillIndex !== -1) {
            if (!TB.isNil(model.self_score)) {
                user = TB.set(user, `skills[${skillIndex}]`, model);
            } else {
                user.skills = TB.filter(user.skills, skill => skill.id !== model.id)
            }
        } else {
            user.skills.push({ ...model })
        }

        user.skills = TB.filter(user.skills, s => !TB.isNil(s?.id))

        await this.props.onChange(user);
    }


    /**
     * Handles form change
     *
     * @returns void
     */
    onChange(model) {
        console.log('onChange', model)
        return this.promisedState({ model })
    }

    hasDisciplines() {
        let disciplines = TB.tryArray(this.props.user?.talent_disciplines);
        return disciplines.filter(({ id }) => TB.isDefined(id));
    }

    /**
     * Render the form
     *
     * @returns {Form}
     */
    render() {

        let {
            model,
            suggestedSkills,
            searchLoading,
            searchError
        } = this.state;

        let {
            disabled,
            isEditing,
            canEdit,
            user
        } = this.props;

        let userSkills = TB.keyBy(user.skills, 'id');

        let talentClass = 'talent-role-form white-panel ';
        if (!canEdit || !this.hasDisciplines()) {
            talentClass += ' no-edit'
        }
        if (disabled) {
            talentClass += ' pointer-events-none opacity-80';
        }
        return (
            <div className={talentClass}>
                <Form
                    title={this.renderTitle(TB.trans('talent.talent_skills_form.title'))}
                    subtitle={null}
                    submitButton={false}
                    onChange={this.onChange.bind(this)}
                    model={model}
                    fields={this.formFields()}
                    isDisabled={disabled}
                >
                    <div style={{ position: 'relative', padding: 15 }}>
                        <div className="discipline-skills-container gap-3">
                            {!searchLoading && !searchError && (
                                <FlipMove typeName={null}>
                                    {suggestedSkills?.length > 0 ? suggestedSkills.map(skill => {
                                        if (TB.isDefined(userSkills[skill.id])) return null
                                        return (
                                            <div key={`skill-${skill.id}`}>
                                                <NEWSkillFormButton
                                                    disabled={this.props.disabled}
                                                    skill={skill}
                                                    className={skill.category && "min-w-[165px]"}
                                                    scoringOptions={skill.category ? laravel.talent_scoring_options_by_category[skill.category] : laravel.talent_scoring_options}
                                                    type={skill.category ? 'info' : 'default'}
                                                    onChange={this.selectSkill.bind(this)}
                                                />
                                            </div>
                                        )
                                    }) : (!TB.isEmpty(model.search) && (
                                        <EmptyBanner
                                            key={"emptyskills"}
                                            message={`${TB.trans('talent.talent_skills_form.empty_skills_message')}${model.search}"`} />
                                    ))}

                                </FlipMove>
                            )}
                            {(searchError && !searchLoading && !TB.isEmpty(model.search) && (
                                <ErrorBanner
                                    key={"errorskills"}
                                    minHeight="unset" />
                            ))}
                        </div>
                    </div>


                </Form>
            </div>
        )
    }

    renderTitle(title) {
        return (
            <span>
                <div className="form-title-section">
                    <div className="step-title-content">
                        <div>
                            <h3 className="form-title">
                                {title}
                            </h3>
                        </div>
                    </div>
                </div>
            </span>
        )
    }


}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};